import React from 'react'
import ReactDOM from 'react-dom/client'
import BabyScheduleApp from './BabyScheduleApp.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BabyScheduleApp />
  </React.StrictMode>,
)